import React, {useState} from "react";
import Grid from "@mui/material/Grid";
import {useSelector} from "react-redux";
import HtmlEditor from "../html-editor";
import I18nInputAdornmentSelect from "../i18n-input-adornment-select";
import {languageSelector, languagesSelector} from "../../state/app/appSelectors";

const I18nHtmlEditor = ({value, onChange, ...htmlEditorProps}) => {
  const languages = useSelector(languagesSelector);
  const defaultLanguage = useSelector(languageSelector);

  const [language, setLanguage] = useState(defaultLanguage);

  return (
    <Grid container direction="column" gap="4px" className={"i18n-html-editor-container"}>
      <Grid container justifyContent="flex-end" className={"i18n-html-editor-container__lang-selector"}>
        <I18nInputAdornmentSelect value={language} onChange={lang => setLanguage(lang)} />
      </Grid>
      <Grid className={"i18n-html-editor-container__editor"}>
        <HtmlEditor
          {...htmlEditorProps}
          value={value && value[language] ? value[language] : ""}
          onChange={val => {
            const res = {};
            languages.forEach(lang => {
              if (value && value[lang]) {
                res[lang] = value[lang];
              }
            });
            res[language] = val;
            onChange(res);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default I18nHtmlEditor;
